import React, { useState, useEffect } from 'react';
import './MobileAccessPrompt.css';
import whiteLogo from '../../../../assets/logo_white.png';

const MobileAccessPrompt = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Adjust width as needed
  const [loading, setLoading] = useState(true);
  const [copyButtonText, setCopyButtonText] = useState('Copy URL');

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1200); // Update based on viewport width
    };

    window.addEventListener('resize', handleResize);
    
    // Initial check
    setIsMobile(window.innerWidth <= 1200);
    setLoading(false); // Stop loading after the check

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

    // Copy URL to clipboard
  const handleCopyLink = () => {
    navigator.clipboard.writeText('https://www.pawsible.app')
      .then(() => {
        setCopyButtonText('Woof!');
        setTimeout(() => setCopyButtonText('Copy URL'), 2000); // Reset button text after 2 seconds
      })
      .catch(() => {
        alert('Failed to copy the URL.');
      });
  };

  if (loading) return null;

  // If not mobile, show the overlay
  if (!isMobile) {
    return (
      <div className="mobile-access-overlay">
        <div className="mobile-access-content">
          <img src={whiteLogo} alt="Pawsible Logo" className="browser-prompt-logo" />
          <h2>Hop on your Mobile!</h2>
          <p>Desktop view is still being groomed.</p>
          {/* <p>www.pawsible.app</p> */}
          <button onClick={handleCopyLink}>
            {copyButtonText}
          </button>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default MobileAccessPrompt;
